// immediate improvements (will apply to new features and api migration)
// - separate store files per service/controller?
// - reduce repeated large codes
// - maximize of enums use
// - taking advantage of async await
// - set 'src' as base url with alias @ for for better definition of paths

// others:
// - shared docs for old API endpoint paired with New Endpoint API for migration
// - remove debugger script before deployment, replace with centralized console log appears when error only
// - reduce warnings on logs
// - remove unused script
import { Post, Get, Put } from "@/utils";
import { ApiPath } from "@/enums";
import loginUtils from "@/utils/login.utils";

export default {
  namespaced: true,
  state: {
    current_user: null,
    applicant_user_info: null
  },
  mutations: {
    SET_USER(state, payload) {
      state.current_user = payload;
    },
    SET_APPLICANT_USER_INFO(state, payload) {
      state.applicant_user_info = payload;
    }
  },
  actions: {
    async login({ commit }, body) {
      // Remove login data from localStorage
      localStorage.removeItem('timeOutTime');
      
      const { data } = await Post(`${ApiPath.Authentication}/login`, body);
      localStorage.setItem("token", data.access_token);

      if (data.access_token) {
        const timeOutTime = new Date().getTime() + (loginUtils.getSessionTimeoutInMilliseconds());
        localStorage.setItem('timeOutTime', timeOutTime);

        const { data: userInfo } = await Get(`${ApiPath.Account}/userinfo`);

        localStorage.setItem("roles", btoa(userInfo.roles));
        commit("SET_USER", userInfo);

        const { data: applicantUserInfo } = await Get(
          `${ApiPath.Account}/getapplicantuserinfo?userId=${userInfo.id}`
        );
        commit("SET_APPLICANT_USER_INFO", applicantUserInfo);
        return userInfo;
      }
    },
    async extendSession({}, userId) {
      const { data } = await Get(
        `${ApiPath.Authentication}/extendusersession?userId=${userId}`
      );
      
      localStorage.removeItem("token");
      localStorage.setItem("token", data.access_token);

      return data.access_token;
    },
    logout({ commit }) {
      // Remove login data from localStorage
      localStorage.removeItem('timeOutTime');

      localStorage.removeItem("token");
      localStorage.removeItem("roles");
      localStorage.removeItem("fromSuperAdmin");

      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');      
      commit("SET_USER", null);

      if (isApprentice) {
        window.location = window.location.origin + "/apprentice-login";
      } else {
        window.location = window.location.origin + "/jobseeker-login";
      }
    },
    async restore({ commit }) {
      const { data: userInfo } = await Get(`${ApiPath.Account}/userinfo`);
      commit("SET_USER", userInfo);

      const { data: applicantUserInfo } = await Get(
        `${ApiPath.Account}/getapplicantuserinfo?userId=${userInfo.id}`
      );
      commit("SET_APPLICANT_USER_INFO", applicantUserInfo);

      return userInfo;
    },
    async passwordReset({}, body) {
      const { email } = body;

      const { data: requestReset } = await Post(
        `${ApiPath.Account}/requestpasswordreset`,
        {
          email,
          userType: 0,
          source: 0
        }
      );
      return requestReset;
    },
    async getUserInfo({ commit }) {
      const { data: userInfo } = await Get(`${ApiPath.Account}/userinfo`);
      commit("SET_USER", userInfo);

      const { data: applicantUserInfo } = await Get(
        `${ApiPath.Account}/getapplicantuserinfo?userId=${userInfo.id}`
      );
      commit("SET_APPLICANT_USER_INFO", applicantUserInfo);
      localStorage.setItem("roles", btoa(userInfo.roles));
      return userInfo;
    },
    async getUserBasicInfo({}, userId) {
      const { data: userInfo } = await Get(
        `${ApiPath.Account}/getuserbasicinfo?userId=${userId}`
      );
      return userInfo;
    },
    async getuserfamiliarity({}) {
      const { data: userFamiliarity } = await Get(
        `${ApiPath.Account}/getuserfamiliarity`
      );
      return userFamiliarity;
    },
    async forgotPassword({}, body) {
      const { data: response } = await Post(
        `${ApiPath.Account}/requestpasswordreset`,
        body
      );
      return response;
    },
    async resetuserpassword({}, body) {
      const { data: resetpassword } = await Put(
        `${ApiPath.Account}/resetuserpassword`,
        body
      );
      return resetpassword;
    },
    async register({}, body) {
      const { data: resetpassword } = await Post(
        `${ApiPath.Account}/registernonorganisationuser`,
        body
      );
      return resetpassword;
    },
    async getpublicprofile({}, userId) {
      const { data: userFamiliarity } = await Get(
        `${ApiPath.Account}/getpublicprofile?userId=${userId}`
      );
      return userFamiliarity;
    },
    async getprofiledetails({}, obj) {
      const { data: userFamiliarity } = await Get(
        `${ApiPath.Account}/getprofiledetails?userid=${obj.userid}&cvid=${obj.cvid}`
      );
      return userFamiliarity;
    },
    async publishprofile({}) {
      const { data: userFamiliarity } = await Post(
        `${ApiPath.Account}/publishprofile`
      );
      return userFamiliarity;
    },
    async unpublishprofile({}) {
      const { data: userFamiliarity } = await Post(
        `${ApiPath.Account}/unpublishprofile`
      );
      return userFamiliarity;
    },
    async confirmcompleteprofile() {
      const { data: confirmed } = await Put(
        `${ApiPath.Account}/confirmcompleteprofile`
      );
      return confirmed;
    }
    //TODO: Moved to other service (Account Service)
    // register({ }, registration) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}apprentice/register`,
    //       registration
    //     )
    //     .then((res) => {
    //       //commit('SET_REGISTRATION', registration);
    //       //return registration;
    //     })
    //     .catch((res) => {
    //       const errors = res.response.data;
    //       throw errors;
    //     });
    // },
    // sendRegEmail({ }, registration) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}apprentice/sendEmail`,
    //       registration
    //     )
    //     .then(() => {
    //       //commit('SET_REGISTRATION', registration);
    //       //return registration;
    //     })
    //     .catch((res) => {
    //       const errors = res.response.data;
    //       throw errors;
    //     });
    // },

    // async findInqueue({ }, queueId) {
    //   const { data: foundQueue } = await Get(`${ApiPath.Account}/findinqueue`, {
    //     queueId,
    //   });
    //   return foundQueue;
    // },
    // async getapprentices() {
    //   const { data: apprentices } = await Get(
    //     `${ApiPath.Account}/getapprentices`
    //   );
    //   return apprentices;
    // },
    // async checkemail({ }, param) {
    //   const { data: foundEmail } = await Get(
    //     `${ApiPath.Account}/findemail`,
    //     param
    //   );
    //   return foundEmail;
    // },
  }
};
